import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  updateOption({ commit, dispatch, getters }, option = {}) {
    return axios
      .put(`/api/parseOptions/${option.id}`, option)
      .then(response => {
        const option = response.data
        return option
      })
  },

  getOptions() {
    return axios.get('/api/parseOptions').then(response => {
      const fields = response.data
      return fields
    })
  },
}
